import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import Seo from "@/components/Seo";
import { Container, SectionLabel, Reveal } from "@/components/primitives";
import { api, mediaSrc } from "@/lib/api";

export default function Projects() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.listProjects().then(setItems).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-lux-bg">
      <Seo title="Projects · Onedot6" description="A small body of recent collaborations — completed alongside architects and interior designers across India." path="/projects" />
      <TopBar />
      <Container className="pt-32 md:pt-40 pb-24">
        <SectionLabel>Selected Work</SectionLabel>
        <h1 className="font-serif text-lux-ink font-light tracking-tight leading-none mt-2 text-5xl md:text-7xl lg:text-8xl">Projects.</h1>
        <p className="text-base md:text-lg text-lux-sec font-light leading-relaxed mt-5 max-w-[720px]">
          A small body of recent collaborations — completed alongside architects and interior designers across India.
        </p>
        <div className="mt-12 md:mt-20 grid md:grid-cols-2 gap-x-10 gap-y-12 md:gap-y-14">
          {loading
            ? Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-[420px] bg-lux-line animate-pulse" />)
            : items.map((p) => (
                <Reveal key={p.id}>
                  <Link to={`/projects/${p.id}`} data-testid={`project-${p.id}`} className="group block">
                    <div className="overflow-hidden bg-lux-line h-[420px] md:h-[480px] mb-4.5 mb-5">
                      <img src={mediaSrc(p.image_url)} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                    </div>
                    <p className="text-[11px] tracking-[0.25em] text-lux-accent mb-2.5">WITH · {p.designer.toUpperCase()}</p>
                    <h2 className="font-serif text-3xl text-lux-ink font-light tracking-tight leading-snug mb-2">{p.name}</h2>
                    <p className="text-[15px] md:text-base text-lux-sec leading-relaxed font-light">{p.summary}</p>
                    {p.location ? <p className="text-[11px] tracking-[0.2em] uppercase text-lux-muted mt-3">{p.location}</p> : null}
                  </Link>
                </Reveal>
              ))}
        </div>
      </Container>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
